import { User } from "..";
import { LoginOutcome, LoginReason } from "../enumerations";

export class LoginAttempt {
	public static readonly $type: string = "LoginAttempt";
	public readonly $type: string = LoginAttempt.$type;

	public outcome!: LoginOutcome;
	public reason!: LoginReason;
	public attemptedAt!: Date;
	public ipAddress!: string;
	public user?: User;
}
